import Vue from 'vue'

// نقطه شکست دسکتاپ (هم‌راستا با $desktop در app.scss)
export const DESKTOP_QUERY = '(min-width: 992px)'

const mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null

const breakpoint = Vue.observable({
    desktop: mq ? mq.matches : false
})

if (mq) {
    const update = e => {
        breakpoint.desktop = e.matches
    }
    if (mq.addEventListener) mq.addEventListener('change', update)
    else if (mq.addListener) mq.addListener(update)
}

export default {
    install(V) {
        // در همه کامپوننت‌ها: this.$bp.desktop
        V.prototype.$bp = breakpoint
    }
}
